<template>
	<div class="skirental-card grid-x grid-margin-x">
		<!-- Image -->
		<div class="cell small-12 medium-4 large-3">
			<div class="skirental-card__image-wrapper">
				<img
					class="skirental-card__image"
					:src="getImgUrl(cardData.imageurl)"
					:alt="cardData.desc3"
				/>
				<span
					class="skirental-card__sticker skirental-card__sticker--blue"
					v-if="cardData.equipmentcategory.includes(1)"
				>
					{{ $t('skirental.recommendedChoice') }}
				</span>
				<span
					class="skirental-card__sticker skirental-card__sticker--grey"
					v-if="
						cardData.equipmentlevel == 2 && cardData.equipmentlevel.length == 1
					"
				>
					{{ $t('skirental.popularChoice') }}
				</span>
			</div>
		</div>

		<!-- Description & dropdowns -->
		<div class="cell small-12 medium-9 large-9">
			<div class="skirental-card__details">
				<h2>
					<strong>{{ cardData.desc3 }}</strong>
					<span
						v-if="cardData.ispackage || cardData.equipmentlevel.length != 3"
						class="skirental-card__levels"
					>
						<LevelLabel
							v-for="label in cardData.equipmentlevel"
							:key="label"
							:level="label"
						>
							{{ getLevelName(label) }}
						</LevelLabel>
					</span>
				</h2>
				<p class="skirental-card__dates">
					{{ dateDiff(cardData.startDate, cardData.endDate) }}
					<template v-if="dateDiff(cardData.startDate, cardData.endDate) == 1">
						{{ $t('day') }} ({{ formatDate(cardData.startDate) }})
					</template>
					<template v-else>
						{{ $t('days') }} ({{
							formatDateSpan(cardData.startDate, cardData.endDate)
						}})
					</template>
				</p>
				<p class="skirental-card__description">
					<span v-html="convertLineBreak(cardData.description)"></span>
				</p>
			</div>

			<div class="skirental-card__group">
				<div
					v-for="ageGroup in cardData.ages"
					:key="ageGroup.id"
					class="skirental-card__group-item"
				>
					<span class="skirental-card__group-age">
						<strong>{{ ageGroup.name }}</strong>
						({{ formatAgeSpan(ageGroup.minage, ageGroup.maxage) }})
					</span>
					<span class="skirental-card__group-price">
						{{ convertPrice(ageGroup.price) }} SEK
					</span>
					<SelectArray
						:data="{
							id: ageGroup.id,
							type: 'skirental',
							index: index,
							poollid: cardData.poollid,
							ageGroup: ageGroup.name,
							fromAge: ageGroup.minage,
							toAge: ageGroup.maxage,
							levels: createLevelArray(cardData.equipmentlevel),
							price: ageGroup.price,
							priceWithInsurance: ageGroup.pricewithinsurance,
							displayLength:
								dateDiff(cardData.startDate, cardData.endDate) +
								' ' +
								$t('days'),
							name: cardData.desc3,
							startDate: ageGroup.startDate,
							endDate: ageGroup.endDate,
							image: getImgUrl(cardData.imageurl),
							isPackage: cardData.ispackage,
							isForSale: cardData.isforsale,
							deliveryPrice: deliveryPrice,
							pricecode: ageGroup.pricecode,
							cat: ageGroup.cat
						}"
						:placeholder="$t('skirental.placeholderQuantity')"
						:defaultSelectedValue="selectedQuantity"
						:option-items="quantityArray"
						:lightTheme="true"
						:small="true"
					/>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import mixin from '../../mixin'
//import moment from 'moment'

import LevelLabel from '../atoms/LevelLabel'
import SelectArray from '../atoms/SelectArray'

export default {
	name: 'SkirentalCard',
	mixins: [mixin],
	components: {
		LevelLabel,
		SelectArray
	},
	data() {
		return {}
	},
	props: {
		cardData: {
			type: Object,
			default: () => {}
		},
		levels: {
			type: Array,
			default: () => []
		},
		deliveryPrice: {
			type: Number,
			default: 0
		},
		index: {
			type: Number
		}
	},
	methods: {
		createLevelArray(ids) {
			var array = []
			var object = {}
			var levelName = ''
			var levels = this.levels

			ids.forEach(function (levelId) {
				levelName = levels.find(each => each.id == levelId).label
				object = { id: levelId, label: levelName }
				array.push(object)
			})
			return array
		}
	}
}
</script>

<style lang="scss">
.skirental-card {
	padding: 35px 0;
	position: relative;
	&:after {
		content: '';
		display: block;
		position: absolute;
		bottom: 0;
		width: calc(100% - 4rem);
		border-bottom: 1px solid #d4d8df;
		margin-left: 2rem;
		margin-right: 2rem;
	}

	&:last-child:after {
		display: none;
	}

	&__image-wrapper {
		position: relative;
	}
	&__image {
		width: 100%;
	}
	&__sticker {
		display: block;
		position: absolute;
		bottom: 15px;
		left: 10px;
		padding: 4px 10px;
		color: $colorWhite;
		font-size: 11px;
		font-weight: 600;
		text-transform: uppercase;
		&--blue {
			@include background($colorSecondary, 0.8);
		}
		&--grey {
			@include background($colorPrimary7, 0.8);
		}
	}

	&__details {
		display: inline-block;
		h2 {
			font-size: 28px;
			line-height: 1.2;
			color: #434449;
			margin: 16px 0;
			@include for-tablet-landscape-up {
				margin: -6px 0 16px;
			}
			strong {
				font-weight: 500;
				vertical-align: middle;
			}
		}
		a {
			font-size: 13px;
			color: $colorPrimary6;
			text-decoration: underline;
		}
	}
	p.skirental-card__dates {
		color: $colorPrimary6;
		font-size: 13px;
		line-height: 1.6;
		margin: 2px 0 10px;
	}
	p.skirental-card__description {
		color: #4a4a4a;
		font-size: 14px;
		line-height: 1.7;
		margin-bottom: 0;
	}

	&__levels {
		display: block;
		margin: 10px 0 0 0;
		vertical-align: middle;
		line-height: 21px;
		> span {
			margin: 5px 10px 5px 0;
		}
		@include for-tablet-landscape-up {
			display: inline-block;
			margin: 0 0 0 30px;
		}
	}

	&__group {
		margin-top: 0px;
		margin-left: -30px;
		overflow: hidden;
		@include for-tablet-portrait-up {
			margin-top: 35px;
		}
	}
	&__group-item {
		float: left;
		padding: 0 30px;
		margin-top: 20px;
		&:last-child {
			border-right: 0;
			padding-right: 0;
		}
		@include for-tablet-portrait-up {
			margin-top: 0px;
			border-right: 1px solid #d4d8df;
		}
	}
	&__group-age {
		display: block;
		color: #434449;
		font-family: Saira;
		font-size: 14px;
		font-weight: 300;
		line-height: 22px;
		margin-bottom: 5px;
		strong {
			font-weight: 500;
		}
	}
	&__group-price {
		color: #434449;
		font-family: Saira;
		font-size: 22px;
		font-weight: 500;
		letter-spacing: 0;
		line-height: 28px;
	}
	.select__container {
		margin-top: 13px;
		.select {
			min-width: 120px;
		}
	}

	// &__price {
	// 	font-size: 20px;
	// 	font-weight: 500;
	// 	color: #434449;
	// }
}
</style>
